<script setup>
import { PlusOutlined, UnorderedListOutlined } from '@ant-design/icons-vue';
import { ref } from 'vue';
import { useDrawerStore } from '~/stores/drawer';

const drawerStore = useDrawerStore();
const datatableRef = ref(null);

function abrirImportacao() {
  drawerStore.push2({
    componentName: 'ImportarAtualizacoesGcpjDrawer',
    params: {},
    onClose: () => {
      datatableRef.value?.fetchData();
    },
  });
}
</script>

<template>
  <Page menu="automacoes-atualizacoes-gcpj">
    <div>
      <a-row justify="center">
        <a-col :xs="24" :md="24" :lg="24" :xl="24">
          <!-- Page header -->
          <a-row>
            <a-col :span="12">
              <a-breadcrumb>
                <a-breadcrumb-item>
                  <router-link to="/automacoes/atualizacoes-gcpj">
                    Atualizacoes GCPJ
                  </router-link>
                </a-breadcrumb-item>
              </a-breadcrumb>
              <h1>
                <UnorderedListOutlined
                  style="color: #bebcbc; font-size: 18px"
                />
                Atualizacoes GCPJ
              </h1>
            </a-col>
            <a-col :span="12">
              <div class="page-header-button-container">
                <a-button type="primary" size="large" @click="abrirImportacao">
                  <template #icon>
                    <PlusOutlined />
                  </template>
                  Importar
                </a-button>
              </div>
            </a-col>
          </a-row>
          <!-- /Page header -->
          <AtualizacoesGcpjDatatable
            ref="datatableRef"
            style="margin-top: 24px"
          />
        </a-col>
      </a-row>
    </div>
  </Page>
</template>
